module.exports = __webpack_public_path__ + "img/g矩形 79@1x.d611e14b.png";